import { appModeUuid, baseUrl } from 'src/utils/capabilities';
import { object } from 'prop-types';
import { ErrorPage } from 'src/components/pages/error/ErrorPage';
import { logError } from './datadogErrorHandling';

const errorHandler = ({ error }) => {
  if (error) {
    logError(error, {
      application_mode_uuid: appModeUuid,
      url: baseUrl,
      error_boundary_fallback: true,
    });
  }
  return <ErrorPage error="defaultError" isSideNavInfoShown />;
};

errorHandler.propTypes = {
  error: object,
};

export { errorHandler };
